import React, { useState } from 'react';
import { 
  Bars3Icon, 
  BellIcon, 
  ChevronDownIcon,
  PlusIcon,
  ListBulletIcon
} from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';
import NotificationCenter from './NotificationCenter';
import MobileMessageMenu from './MobileMessageMenu';

const MobileHeader = ({ 
  title = "FieldHouse", 
  showCommunitySelector = false,
  showTodayButton = false,
  showListToggle = false,
  showAddButton = false,
  onMenuClick,
  onTodayClick,
  onListToggle,
  onAddClick,
  onCommunitySelect
}) => {
  const { user } = useAuth();
  const [showNotificationCenter, setShowNotificationCenter] = useState(false);
  
  // Sample notifications for the bell indicator
  const sampleNotifications = [
    { id: 1, read: false },
    { id: 2, read: false },
    { id: 3, read: true },
  ];

  const unreadCount = sampleNotifications.filter(n => !n.read).length;

  return (
    <>
      {/* Mobile Header */}
      <header 
        className="lg:hidden fixed top-0 left-0 right-0 z-40 bg-white border-b border-gray-200"
        style={{
          paddingTop: 'env(safe-area-inset-top, 0px)'
        }}
      >
        {/* Main Header */}
        <div className="flex items-center justify-between px-4 py-3 bg-white">
          {/* Left Section */}
          <div className="flex items-center space-x-3">
            {/* Menu Button */}
            <button
              type="button"
              onClick={onMenuClick}
              className="p-2 -m-2 text-gray-700 hover:text-gray-900"
            >
              <Bars3Icon className="h-6 w-6" />
            </button>

            {/* Community Selector or Title */}
            {showCommunitySelector ? (
              <div className="flex items-center">
                <button
                  onClick={onCommunitySelect}
                  className="flex items-center text-gray-900 font-medium"
                >
                  Communities
                  <ChevronDownIcon className="ml-1 h-4 w-4" />
                </button>
              </div>
            ) : (
              <h1 className="text-lg font-semibold text-gray-900">{title}</h1>
            )}
          </div>

          {/* Right Section */}
          <div className="flex items-center space-x-2">
            {/* Notifications */}
            <button
              onClick={() => setShowNotificationCenter(true)}
              className="relative p-2 text-gray-700 hover:text-gray-900"
            >
              <BellIcon className="h-5 w-5" />
              {unreadCount > 0 && (
                <span className="absolute top-1 right-1 block h-2 w-2 rounded-full bg-red-500"></span>
              )}
            </button>

            <MobileMessageMenu user={user} />
          </div>
        </div>

        {/* Secondary Actions Row (if needed) */}
        {(showTodayButton || showListToggle || showAddButton) && (
          <div className="flex items-center justify-between px-4 pb-3">
            <div className="flex items-center space-x-3">
              {showTodayButton && (
                <button
                  onClick={onTodayClick}
                  className="px-3 py-1.5 text-sm font-medium text-blue-600 bg-blue-50 rounded-md hover:bg-blue-100"
                >
                  Today
                </button>
              )}
            </div>
            
            <div className="flex items-center space-x-2">
              {showListToggle && (
                <button
                  onClick={onListToggle}
                  className="p-2 text-gray-700 hover:text-gray-900"
                >
                  <ListBulletIcon className="h-5 w-5" />
                </button>
              )}
              
              {showAddButton && (
                <button
                  onClick={onAddClick}
                  className="p-2 text-gray-700 hover:text-gray-900"
                >
                  <PlusIcon className="h-5 w-5" />
                </button>
              )}
            </div>
          </div>
        )}
      </header>

      {/* Notification Center Modal */}
      <NotificationCenter 
        isOpen={showNotificationCenter}
        onClose={() => setShowNotificationCenter(false)}
        user={user}
      />
    </>
  );
};

export default MobileHeader;
